import React, { useState, useRef, useEffect } from 'react';

const IndustryDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  
  const industries = [
    "Technology",
    "Banking and Financial Services",
    "Consulting",
    "Insurance",
    "Government",
    "Legal Services",
    "Hospitality",
    "Airlines and Aviation",
    "Healthcare",
    "Engineering",
    "Education",
    "Non Profit",
    "Media",
    "Defense",
    "Manufacturing",
    "Farming",
    "Human Resources",
    "Finance",
    "Supply Chain",
    "Customer Service",
    "Marketing and Advertising",
    "Sales",
    "Player"
  ];

  const filteredIndustries = industries.filter(industry =>
    industry.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (industry) => {
    onChange(industry);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <div 
        className="flex items-center cursor-pointer border border-transparent hover:border-gray-200 rounded px-2 py-1"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="mr-2">{value || 'Select Industry'}</span>
        <svg 
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-1 w-64 bg-white rounded-md shadow-lg">
          <input
            type="text"
            className="w-full px-4 py-2 border-b focus:outline-none"
            placeholder="Search industries..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="max-h-60 overflow-y-auto">
            {filteredIndustries.map((industry) => (
              <div
                key={industry}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(industry)}
              >
                {industry}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default IndustryDropdown;